export const AF_SUPPORT_PHONE_NUMBER = `(800) 480-5491`
export const AF_SLEEP_CLINICIAN_PHONE_NUMBER = `(866) 650-7508`